<template>
  <div v-if="!item.hidden">
    <template v-if="hasOneShowingChild(item.children, item)">
      <app-link
        v-if="onlyOneChild.meta && !item.meta.isBlank"
        :to="
          item.status === '1'
            ? resolvePath(onlyOneChild.path, onlyOneChild.query)
            : ''
        "
      >
        <el-menu-item
          :index="resolvePath(onlyOneChild.path)"
          :class="{ 'submenu-title-noDropdown': !isNest }"
          :disabled="item.status !== '1'"
        >
          <svg-icon
            :icon-class="
              onlyOneChild.meta.icon || (item.meta && item.meta.icon)
            "
          />
          <template #title
            ><span
              class="menu-title"
              :title="hasTitle(onlyOneChild.meta.title)"
              >{{ onlyOneChild.meta.title }}</span
            ></template
          >
        </el-menu-item>
      </app-link>
      <el-menu-item
        v-else
        :index="resolvePath(onlyOneChild.path)"
        :class="{ 'submenu-title-noDropdown': !isNest }"
        :disabled="item.status !== '1'"
        @click="handleClick($event, item.meta)"
      >
        <svg-icon
          :icon-class="onlyOneChild.meta.icon || (item.meta && item.meta.icon)"
        />
        <template #title
          ><span
            class="menu-title"
            :title="hasTitle(onlyOneChild.meta.title)"
            >{{ onlyOneChild.meta.title }}</span
          ></template
        >
      </el-menu-item>
    </template>

    <el-sub-menu
      v-else
      ref="subMenu"
      :index="resolvePath(item.path)"
      :disabled="item.status !== '1'"
      teleported
    >
      <template v-if="item.meta" #title>
        <!-- <svg-icon :icon-class="item.meta && item.meta.icon" /> -->
        <component v-if="item.meta" :is="AIcon[toCamelCase(item.meta.icon+'Outlined')]"></component>
        <span class="menu-title" :title="hasTitle(item.meta.title)">{{
          item.meta.title
        }}</span>
      </template>

      <sidebar-item
        v-for="child in item.children"
        :key="child.path"
        :is-nest="true"
        :item="child"
        :base-path="resolvePath(child.path)"
        class="nest-menu"
      />
    </el-sub-menu>
  </div>
</template>

<script setup>
import { isExternal } from "@/utils/validate";
import AppLink from "./Link";
import { getNormalPath } from "@/utils/ruoyi";
import * as AIcon from '@ant-design/icons-vue';
import {toCamelCase} from '@/utils/index.js'
const props = defineProps({
  // route object
  item: {
    type: Object,
    required: true,
  },
  isNest: {
    type: Boolean,
    default: false,
  },
  basePath: {
    type: String,
    default: "",
  },
});

const onlyOneChild = ref({});

function hasOneShowingChild(children = [], parent) {
  if (!children) {
    children = [];
  }
  const showingChildren = children.filter((item) => {
    if (item.hidden) {
      return false;
    } else {
      // Temp set(will be used if only has one showing child)
      onlyOneChild.value = item;
      return true;
    }
  });

  // When there is only one child router, the child router is displayed by default
  if (showingChildren.length === 1) {
    return false;
  }

  // Show parent if there are no child router to display
  if (showingChildren.length === 0) {
    onlyOneChild.value = { ...parent, path: "", noShowingChildren: true };
    return true;
  }

  return false;
}

function resolvePath(routePath, routeQuery) {
  if (isExternal(routePath)) {
    return routePath;
  }
  if (isExternal(props.basePath)) {
    return props.basePath;
  }
  if (routeQuery) {
    let query = JSON.parse(routeQuery);
    return {
      path: getNormalPath(props.basePath + "/" + routePath),
      query: query,
    };
  }
  return getNormalPath(props.basePath + "/" + routePath);
}
function handleClick(event, meta = {}) {
  console.log("meta", meta);
  if (meta.isLink && meta.isBlank) {
    window.open(meta.url, "_blank");
    return;
  }
}
function hasTitle(title) {
  if (title.length > 5) {
    return title;
  } else {
    return "";
  }
}
</script>
<style type="scss" scoped>
  :deep(.anticon){
    margin-right: 4px;
  }
  :deep(.el-sub-menu .nest-menu .el-menu-item){
    padding-left: 10px !important;
  }
</style>
